// extracted by mini-css-extract-plugin
module.exports = {"container":"EventTicketsInfoList_container__1GnxN","eventInfo":"EventTicketsInfoList_eventInfo__1NL1I"};